import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=d8fa15b2&"
import script from "./terminal.vue?vue&type=script&lang=js&"
export * from "./terminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports